const ZH_CN = {
    "home-header-title": "你好"
}

export default ZH_CN;

